import { render, staticRenderFns } from "./TermsAgreement.vue?vue&type=template&id=6f5b449b&scoped=true&"
import script from "./TermsAgreement.vue?vue&type=script&lang=js&"
export * from "./TermsAgreement.vue?vue&type=script&lang=js&"
import style0 from "./TermsAgreement.vue?vue&type=style&index=0&id=6f5b449b&scoped=true&lang=scss&"
import style1 from "./TermsAgreement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b449b",
  null
  
)

export default component.exports